import {Component, Input} from '@angular/core';

@Component({
  selector: 'Spinner',
  templateUrl: './Spinner.html',
  styleUrl: './Spinner.css',
  standalone: true,
})
export class Spinner {
  @Input() size: number = 25;
  currentWidth = () => this.size > 12 ? this.size : 12;

}
